
import { Injectable } from '@angular/core';

import * as _ from 'lodash';
import { CDocument } from '../models/CDocument';
import { CommonFunctions } from '../static/common-functions';
import { saveAs } from '@progress/kendo-file-saver';
import { PdfResponse } from '../models/PdfResponse';

@Injectable()
export class PrintService  {
    printPdf(data: CDocument) {
        if (CommonFunctions.hasValue(data) && CommonFunctions.hasValue(data.document)) {
            let document: CDocument = new CDocument(data);
            let downloadData = "data:" + document.mimeType + ";base64," + data.document;
            saveAs(downloadData, document.fileName);
        }
    }

    printIronPdf(data: PdfResponse, fileName: string) {
        if (!CommonFunctions.hasValue(data) || !CommonFunctions.hasValue(data.result)) {
            return;
        }

        if (data.result instanceof Blob) {
            saveAs(data.result, fileName);
            return;
        }

        const resultValue: string = (data.result as any).toString().trim();
        const base64Prefix = 'base64,';
        const base64Index = resultValue.toLowerCase().indexOf(base64Prefix);
        const base64Payload = base64Index >= 0
            ? resultValue.substring(base64Index + base64Prefix.length)
            : resultValue;

        const downloadData = "data:application/pdf;base64," + base64Payload;
        saveAs(downloadData, fileName);
    }

}
